import { z } from 'zod';

export function isSpanishCompanyNif(value: string): boolean {
  if (!/^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/.test(value)) return false;
  const digits = value.slice(1, 8).split('').map(Number);
  const sum = digits.reduce((total, digit, index) => {
    const doubled = digit * 2;
    return total + (index % 2 === 0 ? Math.floor(doubled / 10) + (doubled % 10) : digit);
  }, 0);
  const control = (10 - (sum % 10)) % 10;
  const letter = 'JABCDEFGHI'[control];
  if ('PQRSW'.includes(value[0])) return value[8] === letter;
  if ('ABEH'.includes(value[0])) return value[8] === String(control);
  return value[8] === String(control) || value[8] === letter;
}

const requiredText = z.string().trim().min(1, 'Este campo es obligatorio').max(250);
export const PsiContractingIdentitySchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('PERSONAL') }).strict(),
  z
    .object({
      type: z.literal('COMPANY'),
      legalName: requiredText,
      taxId: z
        .string()
        .trim()
        .transform((value) => value.toUpperCase().replace(/[\s-]/g, ''))
        .refine(isSpanishCompanyNif, 'Introduce un NIF de empresa española válido'),
      address: requiredText,
      postalCode: z
        .string()
        .trim()
        .regex(/^(0[1-9]|[1-4]\d|5[0-2])\d{3}$/, 'Código postal no válido'),
      city: requiredText,
      province: requiredText,
      representativeCapacity: requiredText,
    })
    .strict(),
]);

export type PsiContractingIdentityDTO = z.infer<typeof PsiContractingIdentitySchema>;
export interface PsiContractingProfileDTO {
  identity: PsiContractingIdentityDTO;
  readyToContract: boolean;
  missingFields: string[];
  representative: { name: string; documentType?: string; documentNumber?: string };
}
